import { Alignment, ModelRow } from "@mcleod/core";
import { Component, ComponentSearcher, Panel, Table, TableColumn } from "@mcleod/components";
import { PermsUserAndGroupCache } from "./PermsUserAndGroupCache ";

export class GroupSecureItemTooltip extends Panel {
    private table: Table;
    constructor(userGroupId: string, permsUserCache: PermsUserAndGroupCache) {
        super({ width: 350, height: "40vh", padding: 0 });
        this.table = this.addTable(userGroupId, permsUserCache);
        this.add(this.table);
    }

    private addTable(userGroupId: string, permsUserCache: PermsUserAndGroupCache) {
        const emptyCaption = "No users are assigned to this group";
        const table = new Table({
            emptyCaptionAfterSearch: emptyCaption, // Really only need before search param, but including anyway
            emptyCaptionBeforeSearch: emptyCaption,
            fillHeight: true,
            fillRow: true,
            rowBorderBottomWidth: 0,
            maxHeight: "40vh",
            columnHeadingsVisible: false,
            columns: [ new TableColumn({ cell: { field: "name" } }) ]
        });
        table.textboxFilter?.setProps({width: 165});
        table.addlSearcherCallback = () => [new ComponentSearcher("name"), new ComponentSearcher("id")];

        const userOrGroup = permsUserCache.userGroups[userGroupId];
        userOrGroup?.get("group_membership")?.forEach(member => {
            const memberId = member.user_id;
            const memberName = permsUserCache.getDisplayName("U", memberId);
            table.addRow(new ModelRow(null, false, { name: memberName, id: memberId }), null, {display: true });
        });
        return table;
    }

    public static setupDynamicTooltip(component: Component, userGroupId: string, permsUserCache: PermsUserAndGroupCache) {
        if (component != null) {
            component.tooltipDynamicContent = () => new GroupSecureItemTooltip(userGroupId, permsUserCache);
            component.tooltipDynamicOptions = { position: Alignment.LEFT };
        }
    }
}
